module.exports = __webpack_public_path__ + "static/media/home.a1d8b7ad.png";